// extracted by mini-css-extract-plugin
export var wordContainer = "_rg-0";